import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Analytics } from "@vercel/analytics/react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CompareBar } from "./CompareBar";
import { CompareProvider } from "@/lib/compare-context";
import { FloatingWhatsApp } from "./FloatingWhatsApp";
import { CookieBanner } from "./CookieBanner";

export function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [location.pathname]);

  return (
    <CompareProvider>
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CompareBar />
      <FloatingWhatsApp />
      <CookieBanner />
      <ScrollRestoration />
      <Analytics />
    </CompareProvider>
  );
}
